module.exports = __webpack_public_path__ + "img/moon.808d1bed.svg";